module.exports = __webpack_public_path__ + "static/media/sound-notification.7db471ff.mp3";